const DashBoardDataAction  = (data)=> async dispatch=>{

    try{
        if(data!=null && data!=undefined){
            dispatch({
                type:'DASHBOARDDATA',
                payload:{data:data}
            })
        }
    }catch(err){
        console.log(err)
        dispatch({
            type:"FAIL"
        })
    }

}
export default DashBoardDataAction;